const users = {
  granted: 'Granted',
  notGranted: 'Not granted',
  noUsersToDisplay: 'No users to display',
  permissionFeaturesManage: 'Manage features',
  permissions: 'Permissions',
  permissionUsersList: 'List users',
  user: 'User',
  users: 'Users',
};

export default users;
